import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/pages/HomePage.vue'

const routes = [
  { path: '/', name: 'home', component: HomePage },
  { path: '/services', name: 'services', component: () => import('@/pages/ServicesPage.vue') },
  { path: '/a-propos', name: 'about', component: () => import('@/pages/AboutPage.vue') },
  { path: '/zones-intervention', name: 'zones', component: () => import('@/pages/ZonesPage.vue') },
  { path: '/devis', name: 'devis', component: () => import('@/pages/DevisPage.vue') },
  { path: '/recrutement', name: 'recruitment', component: () => import('@/pages/RecruitmentPage.vue') },
  { path: '/politique-de-confidentialite', name: 'privacy', component: () => import('@/pages/PolitiqueConfidentialitePage.vue') },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/pages/NotFoundPage.vue') },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: 'instant' }
  },
})

export default router
